import * as React from 'react';
import { getImageUrl } from '@/utils/urls';
import { getItem } from '@/redux/modules/item';
import ImageChildren from './ImageChildren';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import Slider from 'react-slick/lib/slider';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

type Props = {
    activeIndex: number;
    className?: string;
    itemId: number;
    onImageIndexChange: Function;
    setShowLightBox: Function;
};

const MobileItemGallery = ({ className, itemId, onImageIndexChange, setShowLightBox }: Props) => {
    const { catalogId, imageVersion, photos = [], sellerId, title } = useSelector((state) => getItem(state, itemId));

    const afterChange = React.useCallback(
        (index: number) => {
            onImageIndexChange(index);
        },
        [onImageIndexChange]
    );

    const settings = {
        adaptiveHeight: false,
        afterChange,
        dots: photos.length > 1,
        infinite: false,
        initialSlide: 0,
        lazyLoad: true,
        slidesToScroll: 1,
        slidesToShow: 1,
    };

    const makeSlidePhotos = React.useCallback(() => {
        return photos.map((imageNumber, index) => {
            const alt = index ? `${title} - ${index + 1}` : title;
            const imageUrl = getImageUrl({
                catalogId,
                imageNumber,
                imageVersion,
                itemId,
                sellerId,
                width: 375,
            });
            const placeholder = getImageUrl({
                catalogId,
                imageNumber,
                imageVersion,
                itemId,
                quality: 15,
                sellerId,
                width: 375,
            });

            const imageProps = {
                alt,
                lazy: index === 0,
                placeholder: index === 0 ? placeholder : false,
                src: imageUrl,
            };
            return (
                <StyledImageWrapper key={index} onClick={() => setShowLightBox(true)}>
                    <ImageWithFallback {...imageProps} />
                </StyledImageWrapper>
            );
        });
    }, [catalogId, imageVersion, itemId, photos, sellerId, setShowLightBox, title]);

    return (
        <StyledMobileItemGallery className={className}>
            <Slider {...settings}>
                {photos.length
                    ? makeSlidePhotos()
                    : [
                          <div key={0} style={{ height: '100%' }}>
                              <ImageWithFallback alt="placeholder" style={{ height: '100%', width: '100%' }} />
                          </div>,
                      ]}
            </Slider>
            <ImageChildren itemId={itemId} />
        </StyledMobileItemGallery>
    );
};

export default MobileItemGallery;

const StyledMobileItemGallery = styled.div`
    div[class='slick-track'] {
        height: 350px;
    }

    div[class*='slick-slide'] {
        & > div {
            height: 100%;
        }
    }
`;

const StyledImageWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 100%;
    }
`;
